import { rawString } from '../components/Language/Language';

/**
 * The language keys used in the attestation flow.
 * These are the texts the user is agreeing to when they sign and submit.
 */
export const ATTESTATION_LANG_KEYS = [
  'Global.review.attestation',
  'Global.review.attestation.instructions.header',
  'Global.review.attestation.instructions.description',
] as const;

export type AttestationLangKey = (typeof ATTESTATION_LANG_KEYS)[number];

export interface AttestationText {
  langKey: string;
  text: string;
}

export interface AttestationData {
  signature: string;
  attestationTexts: AttestationText[];
}

/**
 * Builds attestation data for submission.
 * Collects the signature and attestation texts that the user agreed to.
 */
export const buildAttestationData = ({
  signature,
  translations,
}: {
  signature: string;
  translations: Record<string, string>;
}): AttestationData | null => {
  if (!signature || signature.trim() === '') {
    return null;
  }

  const attestationTexts: AttestationText[] = [];

  for (const langKey of ATTESTATION_LANG_KEYS) {
    const text = rawString({
      langKey,
      translations,
    });

    if (text) {
      attestationTexts.push({ langKey, text });
    }
  }

  return {
    signature: signature.trim(),
    attestationTexts,
  };
};
